webpackJsonp([25,109,198,199,200,201,271,272],{

/***/ 1148:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-progress'), _vm._v(" "), _c('b-progress', {
    attrs: {
      "value": 20
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "value": 40,
      "show-value": ""
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "value": 80,
      "show-value": "",
      "format": "percent"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-progress', {
    attrs: {
      "value": 20
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "type": "is-danger",
      "value": 40
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "type": "is-success",
      "value": 60
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "type": "is-info",
      "value": 80
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "type": "is-warning",
      "value": 100
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-progress', {
    attrs: {
      "size": "is-small"
    }
  }), _vm._v(" "), _c('b-progress'), _vm._v(" "), _c('b-progress', {
    attrs: {
      "size": "is-medium"
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "size": "is-large"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            indeterminate: false,
            type: null,
            size: 'is-medium',
            showValue: true,
            format: 'raw',
            precision: 2,
            keepTrailingZeroes: false
        };
    }
});

/***/ }),

/***/ 1152:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('b-switch', {
    model: {
      value: (_vm.indeterminate),
      callback: function($$v) {
        _vm.indeterminate = $$v
      },
      expression: "indeterminate"
    }
  }, [_vm._v(" Indeterminate ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Type and Size"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Type"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-danger"
    }
  }, [_vm._v("Danger")])]), _vm._v(" "), _c('b-select', {
    attrs: {
      "placeholder": "Size"
    },
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-small"
    }
  }, [_vm._v("Small")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-medium"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-large"
    }
  }, [_vm._v("Large")])])], 1)], 1), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_vm._v(" Show Value ")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.showValue
    },
    model: {
      value: (_vm.keepTrailingZeroes),
      callback: function($$v) {
        _vm.keepTrailingZeroes = $$v
      },
      expression: "keepTrailingZeroes"
    }
  }, [_vm._v(" Keep Trailing Zeroes ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Format and Precision"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.showValue
    },
    model: {
      value: (_vm.format),
      callback: function($$v) {
        _vm.format = $$v
      },
      expression: "format"
    }
  }, [_c('option', {
    attrs: {
      "value": "raw"
    }
  }, [_vm._v("Raw")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percent"
    }
  }, [_vm._v("Percent")])]), _vm._v(" "), _c('b-numberinput', {
    attrs: {
      "disabled": !_vm.showValue,
      "controls-position": "compact"
    },
    model: {
      value: (_vm.precision),
      callback: function($$v) {
        _vm.precision = $$v
      },
      expression: "precision"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-progress', {
    attrs: {
      "type": _vm.type,
      "size": _vm.size,
      "value": _vm.indeterminate ? undefined : 80,
      "show-value": _vm.showValue,
      "format": _vm.format,
      "precision": _vm.precision,
      "keep-trailing-zeroes": _vm.keepTrailingZeroes
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1153:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-progress', {
    attrs: {
      "value": 75,
      "size": "is-medium",
      "show-value": ""
    }
  }, [_vm._v("\n            Custom display with "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("HTML")])]), _vm._v(" "), _c('b-progress', {
    attrs: {
      "value": 75,
      "size": "is-medium",
      "show-value": ""
    }
  }, [_vm._v("\n            75 / 100\n        ")]), _vm._v(" "), _c('b-progress', {
    attrs: {
      "value": 75,
      "size": "is-medium",
      "show-value": ""
    }
  }, [_vm._v("\n            3 out of 4\n        ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_progress__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables_progress__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExTypes__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__examples_ExTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExTypes__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExSizes__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExSizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__examples_ExSizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExValues__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__examples_ExValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExValues__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExSlot__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__examples_ExSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExSlot__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExSlot__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_progress__["default"],
            variables: __WEBPACK_IMPORTED_MODULE_1__variables_progress__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default.a,
            ExTypes: __WEBPACK_IMPORTED_MODULE_4__examples_ExTypes___default.a,
            ExSizes: __WEBPACK_IMPORTED_MODULE_6__examples_ExSizes___default.a,
            ExValues: __WEBPACK_IMPORTED_MODULE_8__examples_ExValues___default.a,
            ExSlot: __WEBPACK_IMPORTED_MODULE_10__examples_ExSlot___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default.a,
            ExTypesCode: __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExTypes___default.a,
            ExSizesCode: __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes___default.a,
            ExValuesCode: __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExValues___default.a,
            ExSlotCode: __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExSlot___default.a
        };
    }
});

/***/ }),

/***/ 1464:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-progress></b-progress>\n\n        <b-progress :value=\"20\"></b-progress>\n\n        <b-progress :value=\"40\" show-value></b-progress>\n\n        <b-progress :value=\"80\" show-value format=\"percent\"></b-progress>\n    </section>\n</template>\n"

/***/ }),

/***/ 1465:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-progress :value=\"20\"></b-progress>\n\n        <b-progress type=\"is-danger\" :value=\"40\"></b-progress>\n\n        <b-progress type=\"is-success\" :value=\"60\"></b-progress>\n\n        <b-progress type=\"is-info\" :value=\"80\"></b-progress>\n\n        <b-progress type=\"is-warning\" :value=\"100\"></b-progress>\n    </section>\n</template>\n"

/***/ }),

/***/ 1466:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-progress size=\"is-small\"></b-progress>\n\n        <b-progress></b-progress>\n\n        <b-progress size=\"is-medium\"></b-progress>\n\n        <b-progress size=\"is-large\"></b-progress>\n    </section>\n</template>\n"

/***/ }),

/***/ 1467:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"block\">\n            <b-switch v-model=\"indeterminate\"> Indeterminate </b-switch>\n            <b-field label=\"Type and Size\">\n                <b-field grouped>\n                    <b-select v-model=\"type\" placeholder=\"Type\">\n                        <option value=\"null\">Default</option>\n                        <option value=\"is-primary\">Primary</option>\n                        <option value=\"is-success\">Success</option>\n                        <option value=\"is-warning\">Warning</option>\n                        <option value=\"is-danger\">Danger</option>\n                    </b-select>\n                    <b-select v-model=\"size\" placeholder=\"Size\">\n                        <option value=\"null\">Default</option>\n                        <option value=\"is-small\">Small</option>\n                        <option value=\"is-medium\">Medium</option>\n                        <option value=\"is-large\">Large</option>\n                    </b-select>\n                </b-field>\n            </b-field>\n            <b-switch v-model=\"showValue\"> Show Value </b-switch>\n            <b-switch v-model=\"keepTrailingZeroes\" :disabled=\"!showValue\"> Keep Trailing Zeroes </b-switch>\n            <b-field label=\"Format and Precision\">\n                <b-field grouped>\n                    <b-select v-model=\"format\" :disabled=\"!showValue\">\n                        <option value=\"raw\">Raw</option>\n                        <option value=\"percent\">Percent</option>\n                    </b-select>\n                    <b-numberinput v-model=\"precision\" :disabled=\"!showValue\" controls-position=\"compact\" />\n                </b-field>\n            </b-field>\n        </div>\n\n        <b-progress\n            :type=\"type\"\n            :size=\"size\"\n            :value=\"indeterminate ? undefined : 80\"\n            :show-value=\"showValue\"\n            :format=\"format\"\n            :precision=\"precision\"\n            :keep-trailing-zeroes=\"keepTrailingZeroes\"></b-progress>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                indeterminate: false,\n                type: null,\n                size: 'is-medium',\n                showValue: true,\n                format: 'raw',\n                precision: 2,\n                keepTrailingZeroes: false\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1468:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-progress :value=\"75\" size=\"is-medium\" show-value>\n            Custom display with <span style=\"color: red\">HTML</span>\n        </b-progress>\n        <b-progress :value=\"75\" size=\"is-medium\" show-value>\n            75 / 100\n        </b-progress>\n        <b-progress :value=\"75\" size=\"is-medium\" show-value>\n            3 out of 4\n        </b-progress>\n    </section>\n</template>\n"

/***/ }),

/***/ 1469:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTypes,
      "code": _vm.ExTypesCode,
      "title": "Types",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSizes,
      "code": _vm.ExSizesCode,
      "title": "Sizes",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExValues,
      "code": _vm.ExValuesCode,
      "title": "Values",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSlot,
      "code": _vm.ExSlotCode,
      "title": "Slot",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("There is also a default slot if you want to display anything you want inside the progress bar")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>type</code>',
        description: 'Type (color) of the progress bar, optional',
        type: 'String',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '<code>is-darkgrey</code>'
    }, {
        name: '<code>size</code>',
        description: 'Size of the progress bar, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '—'
    }, {
        name: '<code>value</code>',
        description: 'The progress value, progress will be indeterminate if undefined.',
        type: 'Number',
        values: '—',
        default: '—'
    }, {
        name: '<code>max</code>',
        description: 'The maximum value for the progress bar.',
        type: 'Number',
        values: '—',
        default: '<code>100</code>'
    }, {
        name: '<code>show-value</code>',
        description: 'If the value should be displayed inside the progress bar.',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>format</code>',
        description: 'Which format should be used to display the value (if <code>show-value</code> is <code>true</code>).\n                              The value will be displayed as-is if using <code>raw</code>. The percent using <code>value</code>\n                              and <code>max</code> will be calculated and displayed if using <code>percent</code>',
        type: 'String',
        values: '<code>raw</code>, <code>percent</code>',
        default: '<code>raw</code>'
    }, {
        name: '<code>precision</code>',
        description: 'How many decimals should be displayed.',
        type: 'Number',
        values: '—',
        default: '<code>2</code>'
    }, {
        name: '<code>keep-trailing-zeroes</code>',
        description: 'Truncate or not the trailing zeroes',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }],
    slots: [{
        name: '<code>default</code>',
        description: 'This will be displayed inside the progress bar instead of the calculated value',
        props: '—'
    }]
}]);

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    name: '<code>$progress-text-color</code>',
    default: '<code>$white</code>'
}]);

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1148),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1149),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1151),
  /* template */
  __webpack_require__(1152),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1463),
  /* template */
  __webpack_require__(1469),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/25.a82a2af2fe582b4bab00.js